import config from "config/config";

export const isEntityUser = (taxType) => {
  const ENTITY_TAX_TYPE_CODE = config.ENTITY_TAX_TYPE_CODE?.split(",");

  if (!taxType || typeof taxType !== "string") return false;
  return ENTITY_TAX_TYPE_CODE.includes(taxType.trim().toUpperCase());
};
